<template>
  <div class="help-popup" :class="{ show: show }">
    <div class="help-popup--container p-2">
      <div class="help-popup--header">
        <h5 class="title">Help</h5>
        <svg
          data-prefix="far"
          data-icon="times-circle"
          class="close"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          @click="hide"
        >
          <path
            fill="currentColor"
            d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"
          />
        </svg>
      </div>
      <div
        class="text-danger browser-setting p-2"
        v-if="!getUserMediaSupported"
      >
        Your browser doesn't support accessing the webcam. So application will
        not function properly. Please visit
        <a href="https://elitefitforyou.com">https://elitefitforyou.com</a> in
        safari browser.
      </div>
      <div class="help-browser" v-else>
        <div class="browser-setting p-2" v-if="browser == 'chrome'">
          <ul>
            <li>1. Open Google Chrome.</li>
            <li>2. At the top right, click 'Menu' and then 'Settings'.</li>
            <li>3. Select 'Privacy and security', click 'Site settings'.</li>
            <li>
              4. Scroll down to permissions and select 'Camera' .
              <ul>
                <li>
                  &bull; &nbsp;&nbsp;Under permissions select 'Allow' in the
                  dropdown for 'Camera'.
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div
          class="browser-setting p-2"
          v-else-if="browser == 'firefox' && isMobile"
        >
          <ul>
            <li>1.Click on Menu.</li>
            <li>2.Click on 'Settings' option</li>
            <li>3. Scroll to the 'Privacy and Security' section.</li>
            <li>4. Click on 'Site Permissions' and select 'Camera' option.</li>
            <li>5. Choose 'Ask to allow' radio button.</li>
          </ul>
        </div>
        <div class="browser-setting p-2" v-else-if="browser == 'firefox'">
          <ul>
            <li>1. Click the menu button</li>
            <li>
              2. Click on 'Options' and select 'Privacy &amp; Security' from the
              left menu.
            </li>
            <li>3. Scroll down to the Permissions section.</li>
            <li>4. Click the Settings button for the Camera option.</li>
            <li>
              5. Enter the website URL in the Search field for the site that you
              want to access your camera.
            </li>
            <li>5. Enable access for the site.</li>
            <li>6. Click the Save Changes button.</li>
          </ul>
        </div>
        <div class="browser-setting p-2" v-else-if="browser == 'ie'">
          <ul>
            <li>1. Open Internet Explore browser.</li>
            <li>
              2. From the Menu Bar, select Tools and then Internet Options.
            </li>
            <li>
              3. Click on the Security tab, select Internet,then click on the
              Custom Level button.
            </li>
            <li>
              4. Please check the settings of ActiveX controls and plug-ins and
              enable it.
            </li>
          </ul>
        </div>
        <div class="browser-setting p-2" v-else-if="browser == 'edge'">
          <ul>
            <li>1.Click on menu.</li>
            <li>2.Click on 'Settings', select 'Site permissions' .</li>
            <li>3. Click on 'Camera'.</li>
            <li>
              4. Turn on 'Ask before accessing(recommended)' radio button.
            </li>
            <li>5. Remove the site url if it is listed in the blocked list.</li>
          </ul>
        </div>
        <div
          class="browser-setting p-2"
          v-else-if="browser == 'safari' && isMobile"
        >
          <ul>
            <li>1.Open the Settings app.</li>
            <li>2.Tap on Safari > Camera.</li>
            <li>3. Click on 'Camera'.</li>
            <li>4. Confirm that 'Ask' or 'Allow' is checked.</li>
            <li>5. Click on 'Retry now' button.</li>
          </ul>
        </div>
        <div class="browser-setting p-2" v-else-if="browser == 'safari'">
          <ul>
            <li>2.Click on Safari > Preferences.</li>
            <li>3. Select 'Camera'.</li>
            <li>
              4. Confirm that 'Ask' or 'Allow' is selected for the website.
            </li>
            <li>5. Click on 'Retry now' button.</li>
          </ul>
        </div>
        <div class="browser-setting p-2" v-else>
          <ul>
            <li>1. Open your browser.</li>
            <li>2. At the top right, Click on menu and then 'Settings'.</li>
            <li>3. Under 'Privacy and security' , click 'Site settings'.</li>
            <li>
              4. Scroll down to permissions and click on 'Camera'.
              <ul>
                <li>Enable camera access for the site.</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div>
        <button class="help-button" v-if="getUserMediaSupported" @click="retry">
          Retry now
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    browser() {
      if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1) {
        return "firefox";
      } else if (/MSIE 10/i.test(navigator.userAgent)) {
        return "ie";
      } else if (
        /MSIE 9/i.test(navigator.userAgent) ||
        /rv:11.0/i.test(navigator.userAgent)
      ) {
        return "ie";
      } else if (/Edge/i.test(navigator.userAgent)) {
        return "edge";
      } else if (
        !!window.chrome &&
        (!!window.chrome.webstore || !!window.chrome.runtime)
      ) {
        return "chrome";
      } else if (
        navigator.userAgent.indexOf("Safari") != -1 &&
        navigator.userAgent.indexOf("Chrome") == -1
      ) {
        return "safari";
      }
    },
    getUserMediaSupported() {
      return (
        !!navigator.getUserMedia ||
        (!!navigator.mediaDevices && !!navigator.mediaDevices.getUserMedia)
      );
    },
    isMobile() {
      const isAndroid = /Android/i.test(navigator.userAgent);
      const isiOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      return isAndroid || isiOS;
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    retry() {
      this.$router.go(0);
    },
    open() {
      this.show = true;
    },
    hide() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.help-popup {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  display: none;
  z-index: 999;

  &--container {
    background: white;
    color: #1c1c1c;
    width: 40%;
  }
  ul li {
    list-style: none;
    padding-bottom: 10px;
    ul li {
      padding-left: 20px;
    }
  }

  &--header {
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    border-bottom: 1px solid #1c1c1c;
    .close {
      height: 20px;
    }
  }
  .help-browser {
    text-align: left;
  }

  .help-button {
    width: 30%;
    margin: auto;
    padding: 10px;
    text-align: center;
    color: #1c1c1c;
    background-color: #28c76f;
    border: 1px solid #28c76f;
  }
}

.help-popup.show {
  display: flex;
}

@media (max-width: 768px) {
  .help-popup {
    &--container {
      width: 90%;
    }
  }
}

@media only screen and (max-device-width: 1023px) and (orientation: landscape) {
  .help-popup {
    align-items: flex-start !important;
    &--container {
      width: 100%;
    }
  }
}
</style>